import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@/api/ApiClientProvider'
import type { CampaignWebsite } from '@/api/campaigns'

import { integrationKeys } from './queryKeys'

/** The tenant's websites, for the pickers on the Integrations pages: one key, one fetcher. */
export function useIntegrationWebsites() {
  const client = useApiClient()
  return useQuery({ queryKey: integrationKeys.websites(client.kind), queryFn: () => client.campaignWebsites() })
}

/** How a website is named wherever an Integrations page shows one: its name and environment. */
export function websiteLabel(website: CampaignWebsite): string {
  return `${website.name} (${website.environment})`
}

/** A website's label from its id, or the raw id when it is not (or no longer) one of the tenant's. */
export function websiteLabelFor(websites: readonly CampaignWebsite[], websiteId: string): string {
  const website = websites.find((candidate) => candidate.id === websiteId)
  return website ? websiteLabel(website) : websiteId
}
